export default ({ request }) => ({
  sampleMetadataOptionsListApi(data = {}) {
    return request({
      url: '/master/sampleMetadataOptions/list',
      method: 'post',
      data,
    })
  },
  sampleMetadataOptionsSaveApi(data = {}) {
    return request({
      url: '/master/sampleMetadataOptions/save',
      method: 'post',
      data,
    })
  },
  materialCategoryTreeV1Api(data = {}) {
    return request({
      url: '/master/material/category/tree',
      method: 'post',
      data,
    })
  },
  materialInfoDetailWithImgAndDocApi(data = {}) {
    return request({
      url: '/master/material/info/detailWithImgAndDoc',
      method: 'post',
      data,
    })
  },
  materialInfoDetailApi(data = {}) {
    return request({
      url: '/master/material/info/detail',
      method: 'post',
      data,
    })
  },


  materialInfoImageListApi(data = {}) {
    return request({
      url: '/master/material/info/image/list',
      method: 'post',
      data,
    })
  },
  materialInfoDocListApi(data = {}) {
    return request({
      url: '/master/material/info/doc/list',
      method: 'post',
      data,
    })
  },
  materialInfoDocDetailApi(data = {}) {
    return request({
      url: '/master/material/info/doc/detail',
      method: 'post',
      data,
    })
  },









  //物料相关调整使用ecom接口，同步更新亚马逊数据

  ecomAmzSkuMaterialSaveMaterialApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuMaterial/saveMaterial',
      method: 'post',
      data,
    })
  },
  setMaterialInfoDefaultImageApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/defaultImage',
      method: 'post',
      data,
    })
  },
  materialInfoImageBatchUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/batch/upload',
      method: 'post',
      data,
    })
  },
  materialInfoImageDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/del',
      method: 'post',
      data,
    })
  },
  materialInfoImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/update/sortOrder',
      method: 'post',
      data,
    })
  },
  materialInfoDocBatchUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/docBatchUpload',
      method: 'post',
      data,
    })
  },
  materialInfoDocDelApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/docDel',
      method: 'post',
      data,
    })
  },
  materialInfoDocUploadApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/material/image/upload',
      method: 'post',
      data,
    })
  },
})
